module.exports = __webpack_public_path__ + "static/media/await.b6b3cc0b.svg";